<ion-app>
  <ion-router-outlet id="main" *ngIf="disableNav"></ion-router-outlet>
  <app-side-menu *ngIf="!disableNav && (breakpoint$ | async) === 'desktop'"></app-side-menu>
  <app-tab-menu *ngIf="!disableNav && (breakpoint$ | async) !== 'desktop'"></app-tab-menu>
</ion-app>